export default {
  confirmationCta: {
    id: 'hyperwallet_kyb_confirmation_cta',
    defaultMessage: 'Go to the next step (Transfer method)',
  },
  confirmationText: {
    id: 'hyperwallet_kyb_confirmation_text',
    defaultMessage:
      'The information submitted must be reviewed and verified before we can remove the restriction from your account. We will notify you as soon as the information received has been reviewed.',
  },
  confirmationTitle: {
    id: 'hyperwallet_kyb_confirmation_title',
    defaultMessage: '1/2 - You completed the first step!',
  },
  hWErrorToastContent: {
    id: 'hyperwallet_kyb_error_toast_content',
    defaultMessage:
      'There is an error creating your account, please contact your SSM.',
  },
  legalCta: {
    id: 'hyperwallet_kyb_legal_cta',
    defaultMessage: 'Learn more about Hyperwallet.',
  },
  legalText: {
    id: 'hyperwallet_kyb_legal_text',
    defaultMessage:
      'Back Market is working closely with Hyperwallet to gather your business information safety. {link, html}',
  },
  loadingText: {
    id: 'hyperwallet_loading_text',
    defaultMessage:
      'Please wait while we reach out to our friends at Hyperwallet',
  },
  title: {
    id: 'hyperwallet_kyb',
    defaultMessage: 'Kyb',
  },
  onboardingModalTitle: {
    id: 'hyperwallet_kyb_onboarding_modal_title',
    defaultMessage: 'Meet Hyperwallet 👋',
  },
  onboardingModalDescription: {
    id: 'hyperwallet_kyb_onboarding_modal_done_section',
    defaultMessage:
      'Get paid quickly and securely with our partner Hyperwallet.',
  },
  onboardingModalToDoSection: {
    id: 'hyperwallet_kyb_onboarding_modal_to_do_section',
    defaultMessage:
      'Start by filling out the Hyperwallet form with a few personal and professional details. Hyperwallet will review and verify your account within 1–3 business days.',
  },
  onboardingModalDoneSection: {
    id: 'hyperwallet_kyb_onboarding_modal_back_button_label',
    defaultMessage: 'Head back to the Onboarding page to continue.',
  },
  onboardingModalButtonLabel: {
    id: 'hyperwallet_kyb_onboarding_modal_button_label',
    defaultMessage: 'Get started',
  },
  alreadyConfigured: {
    id: 'hyperwallet_kyb_already_configured',
    defaultMessage: 'You already have your KYB configured',
  },
}
